import React from 'react';

const StudentHome = () => {
  return (
    <div style={styles.container}>
      <h1 style={styles.heading}>Welcome to Your Student Portal</h1>
      <p style={styles.introText}>
        We’re glad to have you here! To ensure that our team can review your application accurately and promptly, please take a few moments to complete all required sections of your application and upload any relevant documents.
      </p>
      
      <div style={styles.instructions}>
        <h2 style={styles.subheading}>Steps to Complete Your Application</h2>
        <ol style={styles.list}>
          <li>Fill out all sections of your profile and ensure all required fields are completed.</li>
          <li>Upload necessary documents, including proof of identity, academic records, and any supporting documents for financial aid (if applicable).</li>
          <li>Review your information to ensure accuracy and completeness before submission.</li>
        </ol>
        <p style={styles.note}>
          Note: Completing these steps accurately will help the admins review your application quickly and provide you with a response.
        </p>
      </div>

      <button style={styles.button} 
        onMouseEnter={(e) => Object.assign(e.target.style, styles.hover)}
        onMouseLeave={(e) => Object.assign(e.target.style, styles.button)} 
      onClick={() => window.location.href = '/student/application'}>
        Go to Complete Application
      </button>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '800px',
    margin: '0 auto',
    padding: '20px',
    textAlign: 'center',
    backgroundColor: '#f9f9f9',
    borderRadius: '5px',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
  },
  heading: {
    fontSize: '2em',
    marginBottom: '20px',
    color: '#333',
  },
  introText: {
    fontSize: '1.1em',
    color: '#555',
    marginBottom: '20px',
  },
  instructions: {
    textAlign: 'left',
  },
  subheading: {
    fontSize: '1.5em',
    color: '#333',
    marginBottom: '10px',
  },
  list: {
    paddingLeft: '20px',
    marginBottom: '20px',
    color: '#555',
  },
  note: {
    fontSize: '1em',
    fontStyle: 'italic',
    color: '#666',
    marginTop: '10px',
  },
  button: {
    padding: '10px 20px',
    fontSize: '1.1em',
    backgroundColor: '#E60240',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    marginTop: '20px',
  },
  hover: {
    backgroundColor: '#c20035', // Darker red on hover
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
  },
};

export default StudentHome;
